// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"bacc90aa","21":"abbb4473","83":"ba252d67","150":"1dbb397d","323":"8d49e61f","335":"41f2fb30","453":"056bf105","505":"59833f3b","630":"08fca22f","669":"ac2bd295","731":"9a15b301","791":"8501030f","937":"6a8acfd8"}[chunkId] + ".chunk.js";
};